export default __webpack_public_path__ + "62abc33e2a95893e696133b4cafb930b.woff";